import { ReactElement, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  DashboardAggregateType,
  IDashboardVariable,
} from "../types";
import { cloneObject } from "../../../system/utils";
import Select  from "@mui/material/Select";
import { getAggregationText } from "./utils";
// import SpecAnnotationsPanel from "./specAnnotationsPanel";

interface IProps {
  variable: IDashboardVariable;
  onAccept: () => void;
  onCancel: () => void;
}

const aggregate = [
  DashboardAggregateType.None,
  DashboardAggregateType.Average,
  DashboardAggregateType.Count,
  DashboardAggregateType.Minimum,
  DashboardAggregateType.Maximum,
  DashboardAggregateType.Sum,
  DashboardAggregateType.EvalExpression
];

const ConfigItemDialog = ({ variable, onAccept, onCancel }: IProps): ReactElement => {
  const [ cloned, setCloned ] = useState<Record<string, any>>(cloneObject(variable.custom ?? {}));

  const onInternalAccept = () => {
    variable.custom = cloned;
    onAccept();
  };

  const updateCharConfig = (field: string, value: any) => {
    setCloned({ ...cloned, [field]: value });
  };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={true} maxWidth="md">

      <DialogTitle id="customized-dialog-title">
        Variable Config
      </DialogTitle>

      <DialogContent dividers={true}>
        <div style={{ width: 800 }}>
          <div className="display-flex-row flex-wrap">
            <TextField
              variant="standard"
              sx={{ margin: 1, minWidth: 284, width: 284 }}
              placeholder={"Title"}
              label={"Title"}
              value={cloned.title ?? ""}
              onChange={event => updateCharConfig("title", event.target.value as string)}/>

            <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
              <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Align</InputLabel>
              <Select
                variant="standard"
                value={cloned.align ?? "left"}
                displayEmpty={true}
                onChange={event => updateCharConfig("align", event.target.value as string)}>
                <MenuItem value="right">Right</MenuItem>
                <MenuItem value="left">Left</MenuItem>
                <MenuItem value="center">Center</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="display-flex-row flex-wrap">
            <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
              <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Aggregate</InputLabel>
              <Select
                variant="standard"
                value={cloned.aggregate ?? DashboardAggregateType.None}
                displayEmpty={true}
                onChange={event => updateCharConfig("aggregate", event.target.value as DashboardAggregateType)}>
                {aggregate.map((item, uIndex) => {
                  return <MenuItem key={`unit-${item}-${uIndex}`} value={item}>{getAggregationText(item)}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </div>

          {/*<div className="mt-1">*/}
          {/*  <SpecAnnotationsPanel*/}
          {/*    annotations={cloned.annotations ?? []}*/}
          {/*    setAnnotations={annotations => updateCharConfig("annotations", annotations)}/>*/}
          {/*</div>*/}

        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onInternalAccept} variant="contained" color="primary" startIcon={<CheckIcon/>}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon/>}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigItemDialog;
